/**
 * badgeColors.js
 *
 * Single source of truth for chart colours. Keyed by the `cssClass` that config
 * items (severityCodes / statusValues / costCategories) carry — the SAME class
 * that styles the on-screen badge/pill. So charts and pills can never drift, and
 * changing a category/code/status's swatch in the admin config reaches the
 * graphs automatically.
 *
 * Values mirror the .badge.* / .cost-pill rules in styles/global.css (Recharts
 * needs JS hex, so this map mirrors the CSS rather than reading it).
 */
export const CLASS_COLOR = {
  // Severity — solid warm ramp (the badge fill)
  'sev-1': '#F4D353', 'sev-2': '#F1B641', 'sev-3': '#F06B42', 'sev-4': '#DB4339', 'sev-5': '#A43751',
  // Status — blue→teal ramp (the badge dot)
  'status-new': '#2563EB', 'status-open': '#2E7DE0', 'status-inv': '#07B6CE',
  'status-wait': '#06B6D4', 'status-res': '#0D9488', 'status-esc': '#DC2626',
  // Cost categories — the pill's border/text hue
  'cost-refund': '#2563EB', 'cost-goodwill': '#0D9488', 'cost-corrective': '#7C3AED',
  'cost-medical': '#0891B2', 'cost-legal': '#D97706', 'cost-compensation': '#BE185D',
  'cost-other': '#8A94A6',
  // Treatment tags — neutral
  'tx-lhr': '#8A94A6', 'tx-awi': '#8A94A6',
};

const FALLBACK = '#8A94A6'; // --text-3 slate

/** Colour for a cssClass; falls back to neutral slate for unknown/empty. */
export function classColor(cssClass) {
  return CLASS_COLOR[cssClass] || FALLBACK;
}

/** Colour for a config item looked up by a field value (e.g. status value,
 *  severity value, cost-category key). Returns the cssClass colour. */
export function colorForConfigItem(items, matchField, matchValue) {
  const item = (items || []).find(i => i[matchField] === matchValue);
  return classColor(item?.cssClass);
}
